import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { toast } from 'sonner';
import axios from 'axios';
import { Users, UserPlus, Shield, AlertTriangle, Calendar, Key, Settings, Bell, TrendingUp, Activity, BarChart3, FileText, Globe, Zap, Building, Building2, CreditCard, Database, FolderOpen, Layers, Calculator, BookOpen, Video, DollarSign, Package, Handshake, Receipt, Mail, User, FileSignature, Home, HardDrive, Gift, Megaphone, Landmark, QrCode, Award, History, Recycle } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import '../../styles/print-institutional.css';

// Import des composants Phase 3

// Import des nouveaux composants Pro

// FTPERegistreAdherentsAdmin: module SUPPRIMÉ (26/05/2026).

import { getToken } from '../../services/tokenService';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Onglets du dashboard
const _TABS = [
  { id: 'overview', label: 'Vue d\'ensemble', icon: BarChart3 },
  { id: 'validation-manuelle', label: 'Majorations personnalisées', icon: Award },
  { id: 'kpi-dashboard', label: '📈 KPIs', icon: TrendingUp },
  { id: 'analytics', label: '📊 Analytics', icon: TrendingUp },
  { id: 'announcements', label: '📢 Annonces', icon: Megaphone },
  { id: 'ftpe-adhesions', label: '🏢 Adhésions FTPE', icon: Building },
  { id: 'ftpe-virements', label: '🏦 Validation Virements', icon: Landmark },
  { id: 'registres-custom', label: '📚 Registres Custom', icon: BookOpen },
  { id: 'released-accounts', label: '♻️ Comptes libérés', icon: History },
  { id: 'funnels-events', label: '🎯 Funnels & Events', icon: Activity },
  { id: 'conventions-paiements', label: '💳 Conventions Payantes', icon: CreditCard },
  { id: 'communications-section', label: 'COMMUNICATION & ALERTES', isSeparator: true },
  { id: 'alertes-virements', label: '🔔 Alertes Virements', icon: Bell },
  { id: 'alertes-echeances', label: 'Alertes Echeances', icon: Mail },
  { id: 'email-tracking', label: 'Suivi Emails', icon: Mail },
  { id: 'email-preview', label: '✉️ Aperçu Emails', icon: Mail },
  { id: 'demandes-partenariat', label: '🤝 Partenariats', icon: Handshake },
  { id: 'demandes-remises', label: '♻️ Demandes remises', icon: Recycle },
  { id: 'partenariats-section', label: 'COMPTES, PLANS & CRÉDITS', isSeparator: true },
  { id: 'identifiants', label: '🔑 Identifiants', icon: Key },
  { id: 'plans', label: '📦 Plans', icon: Package },
  { id: 'subscription-types', label: '🏷️ Types de souscription', icon: Layers },
  { id: 'factures-plans', label: '💼 Factures Plans (PADH-)', icon: FileText },
  { id: 'propositions-signees', label: '✍️ Propositions signées', icon: FileSignature },
  { id: 'registre-pcs', label: '📜 Registre PCS (ESS)', icon: Award },
  { id: 'seuils-echelonnement', label: '💳 Seuils SEPA échelonnés', icon: CreditCard },
  { id: 'registre-fiscal', label: '⚖️ Registre Fiscal', icon: FileText },
  { id: 'credits', label: '🪙 Crédits', icon: CreditCard },
  { id: 'credits-guide-cms', label: '📖 Guide Crédits (CMS)', icon: BookOpen },
  { id: 'audit-credits', label: '📋 Audit Crédits', icon: Shield },
  { id: 'bonus-programmes', label: '🎁 Bonus Programmés', icon: Gift },
  { id: 'promotions', label: '⚡ Promos Flash', icon: Zap },
  { id: 'gestion-membres', label: 'Création Membres', icon: UserPlus },
  { id: 'comptes-test', label: '🧪 Comptes de test', icon: UserPlus, externalRoute: '/admin/comptes-test' },
  { id: 'export-stats', label: '📊 Export & Stats', icon: TrendingUp },
  { id: 'ged-section', label: 'GED & DOCUMENTATION', isSeparator: true },
  { id: 'backups', label: '💾 Backups', icon: HardDrive },
  { id: 'rgpd-zip-shares', label: '🛡️ Audit RGPD ZIP', icon: Shield },
  { id: 'rgpd-unified', label: '🛡️ Registre RGPD Unifié', icon: Shield },
  { id: 'ged-ess', label: 'GED ESS', icon: FolderOpen },
  { id: 'ged-statistiques', label: 'Statistiques GED', icon: BarChart3 },
  { id: 'cartographie', label: 'Cartographie', icon: Globe },
  { id: 'collections', label: 'Collections', icon: Database },
  { id: 'categories', label: 'Catégories', icon: FolderOpen },
  { id: 'nomenclatures', label: 'Nomenclatures', icon: BookOpen },
  { id: 'simulateurs-separator', label: '🎯 SIMULATEURS MAÎTRES', isSeparator: true },
  { id: 'simulateur-batico', label: '🧮 BATICO Calculateur', icon: Calculator },
  { id: 'simulateur-dos', label: 'DOS-DOMIUM', icon: Home },
  { id: 'cockpit-ccmi', label: '🏗️ Cockpit CCMI', icon: Building2, externalRoute: '/admin/ccmi-dashboard' },
  { id: 'gestion-financiere-domium', label: '💰 Gestion Financière DOMIUM', icon: CreditCard },
  { id: 'batico-config-advanced', label: '🚀 Config BATICO Avancée', icon: Settings },
  { id: 'coopers-experts', label: "COOPER'S & EXPERTS", icon: Building },
  { id: 'suivi-section', label: 'SUIVI & TRAÇABILITÉ', isSeparator: true },
  { id: 'rappels-dashboard', label: "🔔 Suivi Rappels", icon: Bell },
  { id: 'factures-recus', label: "Factures et reçus ESS", icon: Receipt },
  { id: 'suivi-rcds', label: 'Suivi RCDS', icon: Shield },
  { id: 'suivi-dos-domium', label: 'Suivi DOS DOMIUM', icon: Building2 },
  { id: 'tarifs-demandes', label: 'Tarifs Leads', icon: DollarSign },
  { id: 'conventions', label: 'Conventions Partenariat', icon: FileText },
  { id: 'videos', label: 'Vidéos', icon: Video },
  { id: 'operations-section', label: 'OPÉRATIONS & SYSTÈME', isSeparator: true },
  { id: 'export-import', label: 'Export/Import', icon: Database },
  { id: 'alerts', label: 'Alertes', icon: AlertTriangle },
  { id: 'agenda', label: 'Agenda', icon: Calendar },
  { id: 'roles', label: 'Rôles', icon: Shield },
  { id: 'assignments', label: 'Assignations', icon: Users },
  { id: 'messagerie', label: 'Messagerie', icon: Mail },
  { id: 'config-emails-clients', label: 'Config Emails Clients', icon: Mail },
  { id: 'journal-emails', label: 'Journal Emails', icon: Mail },
  { id: 'registre-qr', label: 'Registre QR Codes', icon: QrCode },
  { id: 'code-health', label: '⚙️ Code Health', icon: Activity },
  { id: 'nav-config', label: '🧭 Navigation (onglets)', icon: Layers, externalRoute: '/admin/navigation-config' },
  { id: 'frontoffice-nav', label: '🧭 Menus front-office', icon: Layers },
  { id: 'frontoffice-footer', label: '🦶 Pied de page', icon: Layers },
  { id: 'profil', label: 'Mon Profil', icon: User }
];

export function useSuperAdmin() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  // V36.69 — lit `?tab=X` au montage pour que les liens externes (notifications,
  // emails) puissent ouvrir directement la bonne section du tableau de bord.
  const initialTab = searchParams.get('tab') || 'overview';
  const [activeTab, setActiveTab] = useState(initialTab);

  // Synchronise l'URL ↔ activeTab pour que recharger / partager le lien garde
  // la section ouverte. Évite la boucle infinie en ne touchant que si différent.
  useEffect(() => {
    const current = searchParams.get('tab') || 'overview';
    if (current !== activeTab) {
      const next = new URLSearchParams(searchParams);
      if (activeTab === 'overview') next.delete('tab');
      else next.set('tab', activeTab);
      setSearchParams(next, { replace: true });
    }
    // eslint-disable-next-line
  }, [activeTab]);
  const [assignments, setAssignments] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [allUsers, setAllUsers] = useState({ members: [], coopers: [], experts: [] });
  const [loading, setLoading] = useState(true);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState('');
  const [selectedUser, setSelectedUser] = useState({ id: '', type: '' });
  const [dashboardStats, setDashboardStats] = useState(null);
  const [kpiMensuel, setKpiMensuel] = useState(null);
  const [user, setUser] = useState(null);
  const [showAccountRecovery, setShowAccountRecovery] = useState(false);
  const [refreshing, setRefreshing] = useState(false);

  const handleRefreshOverview = async () => {
    if (refreshing) return;
    setRefreshing(true);
    try {
      await Promise.all([
        loadUserInfo(),
        loadDashboardStats(),
        loadAssignmentsData(),
      ]);
      toast.success('Tableau de bord actualisé');
    } catch {
      toast.error('Erreur lors de l\'actualisation');
    } finally {
      setRefreshing(false);
    }
  };

  const getAuthHeader = () => {
    const token = getToken();
    return { Authorization: `Bearer ${token}` };
  };

  useEffect(() => {
    const init = async () => {
      try {
        // Charger en parallèle pour accélérer le chargement
        const promises = [loadUserInfo(), loadDashboardStats()];
        if (activeTab === 'assignments' || activeTab === 'overview') {
          promises.push(loadAssignmentsData());
        }
        await Promise.all(promises);
      } catch (error) {
        console.error('[SuperAdminDashboard] init failed:', error);
      }
    };
    init();
  }, [activeTab]);

  const loadUserInfo = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/auth/me`,
        { headers: getAuthHeader() }
      );
      setUser(response.data);
    } catch (error) {
      console.error('[SuperAdminDashboard] loadUserInfo failed:', error);
    }
  };

  const loadDashboardStats = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/alerts/dashboard-summary`,
        { headers: getAuthHeader() }
      );
      setDashboardStats(response.data);
    } catch (error) {
      console.error('[SuperAdminDashboard] loadDashboardStats failed:', error);
    }
  };

  const loadAssignmentsData = async () => {
    try {
      setLoading(true);
      
      // Charger les assignations
      const assignmentsRes = await axios.get(
        `${BACKEND_URL}/api/superadmin/assignments`,
        { headers: getAuthHeader() }
      );
      setAssignments(assignmentsRes.data);

      // Charger tous les admins
      const adminsRes = await axios.get(
        `${BACKEND_URL}/api/users`,
        { headers: getAuthHeader() }
      );
      // L'API retourne {users: [...]} donc on accède à .users
      const usersData = adminsRes.data?.users || adminsRes.data || [];
      setAdmins(Array.isArray(usersData) ? usersData.filter(u => u.role === 'admin') : []);

      // Charger tous les utilisateurs
      const [membersRes, coopersRes, expertsRes] = await Promise.all([
        axios.get(`${BACKEND_URL}/api/membres`, { headers: getAuthHeader() }),
        axios.get(`${BACKEND_URL}/api/coopers`, { headers: getAuthHeader() }),
        axios.get(`${BACKEND_URL}/api/experts`, { headers: getAuthHeader() })
      ]);

      setAllUsers({
        members: membersRes.data?.membres || membersRes.data || [],
        coopers: coopersRes.data?.coopers || coopersRes.data || [],
        experts: expertsRes.data?.experts || expertsRes.data || []
      });

      // KPI mensuel (devis signés + encaissé ce mois)
      try {
        const kpiRes = await axios.get(`${BACKEND_URL}/api/super-admin-cms/kpi-mensuel`, { headers: getAuthHeader() });
        setKpiMensuel(kpiRes.data);
      } catch (kpiErr) {
        console.error('[SuperAdminDashboard] kpi-mensuel failed:', kpiErr);
      }

    } catch (error) {
      console.error('[SuperAdminDashboard] loadAssignmentsData failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateAssignment = async () => {
    if (!selectedAdmin || !selectedUser.id || !selectedUser.type) {
      toast.error('Veuillez sélectionner un admin et un utilisateur');
      return;
    }

    try {
      await axios.post(
        `${BACKEND_URL}/api/superadmin/assign`,
        {
          admin_id: selectedAdmin,
          assigned_user_id: selectedUser.id,
          assigned_user_type: selectedUser.type
        },
        { headers: getAuthHeader() }
      );

      toast.success('Assignation créée avec succès !');
      setShowAssignModal(false);
      setSelectedAdmin('');
      setSelectedUser({ id: '', type: '' });
      loadAssignmentsData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de l\'assignation');
    }
  };

  const handleDeleteAssignment = async (assignmentId) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette assignation ?')) {
      return;
    }

    try {
      await axios.delete(
        `${BACKEND_URL}/api/superadmin/assign/${assignmentId}`,
        { headers: getAuthHeader() }
      );

      toast.success('Assignation supprimée');
      loadAssignmentsData();
    } catch {
      toast.error('Erreur lors de la suppression');
    }
  };

  const getUnassignedUsers = () => {
    const assignedIds = new Set(assignments.map(a => a.assigned_user_id));
    
    return {
      members: allUsers.members.filter(m => !assignedIds.has(m.id)),
      coopers: allUsers.coopers.filter(c => !assignedIds.has(c.id)),
      experts: allUsers.experts.filter(e => !assignedIds.has(e.id))
    };
  };

  const unassignedUsers = getUnassignedUsers();

  return { activeTab, admins, allUsers, assignments, dashboardStats, getAuthHeader, getUnassignedUsers, handleCreateAssignment, handleDeleteAssignment, handleRefreshOverview, initialTab, kpiMensuel, loadAssignmentsData, loadDashboardStats, loadUserInfo, loading, navigate, refreshing, searchParams, selectedAdmin, selectedUser, setActiveTab, setAdmins, setAllUsers, setAssignments, setDashboardStats, setKpiMensuel, setLoading, setRefreshing, setSearchParams, setSelectedAdmin, setSelectedUser, setShowAccountRecovery, setShowAssignModal, setUser, showAccountRecovery, showAssignModal, t, unassignedUsers, user };
}
